import { useState } from 'react';

import { message } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import { T } from 'react-translator-component';

import { changePassword } from '../../../../services/authentication';

export const useChangePasswordPage = () => {
  const history = useHistory();
  const location = useLocation();

  const [recaptchaResponse, setRecaptchaResponse] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const [isLoginLoading, setIsLoginLoading] = useState(false);

  const [password, setPassword] = useState('');
  const [validations, setValidations] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    special: false,
    number: false,
  });

  const validatePassword = (value: string) => {
    setValidations({
      length: value.length >= 8 && value.length <= 25,
      uppercase: /[A-Z]/.test(value),
      lowercase: /[a-z]/.test(value),
      special: /[!@#$%^&*()_\-+=<>?/\\|{}~:;.,'"€£¥₩÷]|\[|\]/.test(value),
      number: /\d/.test(value),
    });
  };

  const isPasswordValid = () => {
    return validations.length && validations.uppercase && validations.lowercase && validations.special && validations.number;
  };

  const onChangeSuccess = () => {
    setIsLoginLoading(false);

    history.push('/auth/login');

    message.success(T('Password changed successfully!'));
  };

  const onChangeFailed = (status) => {
    setIsLoginLoading(false);

    if (status == 410 || status == 404) {
      message.error(T('The code has expired.'));
    } else if (status == 429) {
      message.error(T('Exceeded number of attempts'));
    } else {
      message.error(T('Check that the entered code is valid.'));

      (window as any).grecaptcha.reset();

      return;
    }

    message.error(T('You will be redirected to the Login screen.'));

    setTimeout(() => history.push('/auth/login'), 2000);
  };

  const recaptchaLoaded = (response) => {
    if (response) {
      setRecaptchaResponse(response);
      setIsVerified(true);
    }
  };

  const recaptchaExpired = () => {
    setIsVerified(false);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    event.persist();

    const userForm = {
      email: (location as any).state.email,
      code: event.target.code.value,
      password: event.target.password.value,
      recaptchaResponse: recaptchaResponse
    };

    setIsLoginLoading(true);

    // IIFE to make it async with the request
    ;(async () => {
      const changedPassword = await changePassword(userForm);
      
      const {
        data: { error },
        status,
        type,
      } = changedPassword;

      type === 'success' && !error ? onChangeSuccess() : onChangeFailed(status);
    })();
  };

  return {
    handleFormSubmit,
    isLoginLoading,
    isVerified,
    recaptchaExpired,
    recaptchaLoaded,
    password,
    setPassword,
    validations,
    validatePassword,
    isPasswordValid,
  };
};
